import { OWN_HOME_MORTGAGE_LTV } from "web_myplann/Inspiration/OwnHome/constants";
import type {
	OwnHomeContext,
	OwnHomeGoalPreset,
} from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";

const roundToHundredThousand = (value: number) =>
	Math.round(value / 100_000) * 100_000;

export const mapOwnHomeGoalPreset = (
	context: OwnHomeContext,
): OwnHomeGoalPreset => {
	const totalValue = roundToHundredThousand(context.priceHigh);
	const loanAmount = roundToHundredThousand(totalValue * OWN_HOME_MORTGAGE_LTV);
	const ownFunds = context.savings;

	return {
		totalValue,
		loanAmount,
		ownFunds,
		savingsTarget: Math.max(0, totalValue - loanAmount - ownFunds),
	};
};
